import { graphql } from 'gql/generated/gql'

export const GET_TRIP_DRIVER = graphql(`
  query GetTripDriver($input: TDriverInput!) {
    tdriver(input: $input) {
      id
      partner {
        id
        name
      }
      userAccount {
        id
        firstName
        lastName
        email
        phoneNumber {
          number
          countryCode
        }
        gender
      }
      documents {
        document {
          name
          path
        }
        category
      }
    }
  }
`)

export const TRIP_NOTE_FRAGMENT = graphql(`
  fragment TripNotes on TripV2 {
    notes {
      category
      subcategory
      message
      changeType
      user {
        id
        firstName
        lastName
        username
      }
      createdAt
      files {
        name
        path
      }
      cashFlow {
        type
        amount
      }
      driver {
        id
        firstName
        lastName
        rsvpStatus
      }
      distance
    }
  }
`)

export const GET_TRIP_V2 = graphql(`
  query GetTripV2($input: TripV2Input!) {
    tripV2(input: $input) {
      id
      status
      saleStatus
      departureAt
      arrivalAt
      confirmedSeatsNumber
      serviceScore
      availableSeatsNumber
      vertical
      route {
        id
        name
        polyline {
          encoded
        }
      }
      routeService {
        id
        code
        businessClients {
          id
          name
          businessSites {
            id
            name
          }
        }
      }
      legSegments {
        id
        destination {
          id
          name
        }
        origin {
          id
          name
        }
      }
      company {
        id
      }
      companyLine {
        id
        name
      }
      driver {
        id
        firstName
        lastName
        RSVP {
          status
          attempt
        }
      }
      itinerary {
        realDepartureTime
        place {
          id
          name
          timezone
        }
        departure {
          day
          time
        }
        arrival {
          day
          time
        }
        checkIns {
          at
          method
        }
        checkOuts {
          at
          method
        }
      }
      ...TripNotes
      timeline {
        correlationID
        placeID
        type
        createdAt
        user {
          id
          firstName
          lastName
          username
        }
        tripCancellationReason {
          category
          subcategory
        }
      }
      crewUsers {
        id
        firstName
        lastName
        username
      }
      confirmationModalities {
        name
        salesChannels {
          id
          name
        }
        exceptions {
          places {
            id
            name
          }
        }
      }
      vehicle {
        id
        externalID
        name
        schedule {
          id
          type
        }
      }
    }
  }
`)

export const GET_TRIPS = graphql(`
  query GetTrips($pagination: PaginationV2!, $input: TripsV2Input!) {
    tripsV2(input: $input, pagination: $pagination) {
      total
      items {
        id
        status
        saleStatus
        departureAt
        arrivalAt
        confirmedSeatsNumber
        serviceScore
        availableSeatsNumber
        vertical
        route {
          id
          name
        }
        routeService {
          id
          code
          businessClients {
            id
            name
            businessSites {
              id
              name
            }
          }
        }
        legSegments {
          id
          destination {
            id
            name
          }
          origin {
            id
            name
          }
        }
        company {
          id
        }
        companyLine {
          id
          name
        }
        vehicle {
          id
          name
          externalID
          schedule {
            type
          }
        }
        driver {
          id
          firstName
          lastName
          RSVP {
            status
            attempt
          }
        }
        itinerary {
          realDepartureTime
          place {
            id
            name
            timezone
          }
          arrival {
            time
            day
          }
          departure {
            time
            day
          }
        }
        timeline {
          user {
            id
            firstName
            lastName
            username
          }
          type
          correlationID
          createdAt
          placeID
        }
        ...TripNotes
        routeService {
          code
        }
        crewUsers {
          id
          firstName
          lastName
          username
        }
        confirmationModalities {
          name
          salesChannels {
            id
            name
          }
          exceptions {
            places {
              id
              name
            }
          }
        }
      }
    }
  }
`)
